import React from 'react';
import { Button, Container, Grid, Stack, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';

import { Link } from 'react-router-dom';
import {
	LABEL_BACKTOTEXTPAGE,
	LABEL_BGCOLOR,
	SCREEN_NAMES,
	LABEL_FONTCOLOR,
	LABEL_FONTSIZE,
	LABEL_FONTTYPE,
	SUBTITLE_BGOPACITY,
	SUBTITLE_BGSETTINGS,
	SUBTITLE_FONTSETTINGS,
	LABEL_STROKECOLOR,
	LABEL_LINEHEIGHT,
	SUBTITLE_CANVAS,
	LABEL_CANVASWIDTH,
	LABEL_BGNOISE,
} from './const';
import BgImageSelectTabs, { P_BgImageSelectTabs } from './BgImageSelectTabs';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import NumberInputForm, { P_NumberInputFormBase } from './NumberInputForm';
import SelectorForEdit, { P_SelectorForEditBase } from './SelectorForEdit';
import Canvas, { P_Canvas } from './Canvas';
import RadioButtonsForEdit, {
	P_RadioButtonsForEditBase,
} from './RadioButtonsForEdit';
import { t_loading } from './Product';
import LoadingBgImage from './LoadingBgImage';
import SliderForEdit, { P_SliderForEditBase } from './SliderForEdit';
import InputColor, { P_InputColorBase } from './InputColor';
import SaveButton, { P_SaveButton } from './SaveButton';
import ImgurButton, { P_ImgurButton } from './ImgurButton';
import ImgurResult from './ImgurResult';

export default function ScreenEdit(props: {
	propsSaveButton: P_SaveButton;
	propsImgurButton: P_ImgurButton;
	bgImageLoading: t_loading;
	propsBgImageSelectTabs: P_BgImageSelectTabs;
	propsBgImageModeRadioButton: P_RadioButtonsForEditBase;
	propsBgOpacitySlider: P_SliderForEditBase;
	propsBgColorInput: P_InputColorBase;
	propsBgNoiseRadioButton: P_RadioButtonsForEditBase;
	propsFontFamilySelector: P_SelectorForEditBase<string>;
	propsFontSizeSelector: P_SelectorForEditBase<number>;
	propsFontColorInput: P_InputColorBase;
	//propsColorPicker: P_ColorPicker;
	propsFontStrokeColorRadioButton: P_RadioButtonsForEditBase;
	propsLineHeightForm: P_NumberInputFormBase;
	propsStageWidth: P_NumberInputFormBase;
	propsCanvas: P_Canvas;
}) {
	const outputFontFamilyItem = React.useCallback(
		(e: string) => e.split(',')[0],
		[],
	);

	return (
		<Container maxWidth={'lg'}>
			<Grid
				container
				spacing={3}
				direction='row-reverse'
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'flex-start',
				}}
			>
				<Grid item md={4} sm={12} width={'100%'} zeroMinWidth>
					<Stack spacing={3}>
						<Button
							variant='text'
							size='small'
							startIcon={<ArrowBackIosNewIcon />}
							sx={{ justifyContent: 'flex-start' }}
							component={Link}
							to={SCREEN_NAMES.home}
						>
							{LABEL_BACKTOTEXTPAGE}
						</Button>
						<Stack direction='row' spacing={2}>
							<SaveButton {...props.propsSaveButton} />
							<ImgurButton {...props.propsImgurButton} />
						</Stack>
						{props.propsImgurButton.imgurUrl !== '' && (
							<ImgurResult url={props.propsImgurButton.imgurUrl} />
						)}

						<SectionTitle title={SUBTITLE_BGSETTINGS} />

						<BgImageSelectTabs {...props.propsBgImageSelectTabs} />

						{/*<Divider /> */}

						{props.bgImageLoading !== 'SUCCESS' ? (
							<LoadingBgImage loading={props.bgImageLoading} />
						) : (
							<>
								<RadioButtonsForEdit
									{...props.propsBgImageModeRadioButton}
									id={'bg-image-mode-radiobuttons'}
								/>
								<SectionSubTitle title={SUBTITLE_BGOPACITY} />
								<SliderForEdit
									{...props.propsBgOpacitySlider}
									id='bg-opacity-slider'
									min={0}
									max={1}
									step={0.1}
								/>
							</>
						)}

						<InputColor
							{...props.propsBgColorInput}
							id={'bg-input-color'}
							label={LABEL_BGCOLOR}
						/>

						<RadioButtonsForEdit
							{...props.propsBgNoiseRadioButton}
							id={'bg-noise'}
							label={LABEL_BGNOISE}
							row={true}
						/>

						<SectionTitle title={SUBTITLE_FONTSETTINGS} />

						<SelectorForEdit
							{...props.propsFontFamilySelector}
							id={'font-family-selector'}
							label={LABEL_FONTTYPE}
							valueOutput={outputFontFamilyItem}
						/>

						<SelectorForEdit
							{...props.propsFontSizeSelector}
							id='font-size'
							label={LABEL_FONTSIZE}
						/>

						<InputColor
							{...props.propsFontColorInput}
							id={'font-input-color'}
							label={LABEL_FONTCOLOR}
						/>

						{/*
						<div>
							<SectionSubTitle title={'文字色'} />

							<ColorPicker
								colorList={props.propsColorPicker.colorList}
								selectedColor={props.propsColorPicker.selectedColor}
								onChange={props.propsColorPicker.onChange}
							/>
						
						</div>
	*/}
						<RadioButtonsForEdit
							{...props.propsFontStrokeColorRadioButton}
							id={'font-stroke-color'}
							label={LABEL_STROKECOLOR}
							row={true}
						/>

						<NumberInputForm
							id={'line-height'}
							label={LABEL_LINEHEIGHT}
							shrink={true}
							value={props.propsLineHeightForm.value}
							onChange={props.propsLineHeightForm.onChange}
							inputStep={0.1}
						/>

						<SectionTitle title={SUBTITLE_CANVAS} />

						<NumberInputForm
							id={'stage-width'}
							label={LABEL_CANVASWIDTH}
							shrink={true}
							value={props.propsStageWidth.value}
							onChange={props.propsStageWidth.onChange}
							inputStep={1}
						/>
					</Stack>
				</Grid>
				<Grid
					item
					md={8}
					sm={12}
					zeroMinWidth
					sx={{ display: 'flex', justifyContent: 'center' }}
				>
					<ScrollableContainer>
						<Canvas {...props.propsCanvas} />
					</ScrollableContainer>
				</Grid>
			</Grid>
		</Container>
	);
}

const SectionTitle = (props: { title: string }) => (
	<Typography variant='h6'>{props.title}</Typography>
);
const SectionSubTitle = (props: { title: string }) => (
	<Typography variant='subtitle2' color={'textSecondary'} gutterBottom>
		{props.title}
	</Typography>
);

const ScrollableContainer = (props: { children: React.ReactElement }) => {
	return (
		<Paper
			elevation={3}
			style={{
				overflow: 'auto',
				maxWidth: '100%',
				//maxHeight: '90vh',
			}}
		>
			{props.children}
		</Paper>
	);
};
